const DEFAULT_EXCLUSION = [
  {
    key: 1,
    text: "All work or activities performed by the name insured's employee or laborer, whether day laborer or temporary worker or part-time or full-time worker.",
  },
  {
    key: 2,
    text: 'All work or activities involving the use of a tower crane.',
  },
  {
    key: 3,
    text: 'All work or activities performed prior to inception of this policy',
  },
];

const getExclusionU650 = () => {
  return DEFAULT_EXCLUSION;
}
const updateExclusionU650 = (submission) => {
  if (submission.type === 'oi') {
    let u650Exclusion = submission && submission.ratings && submission.ratings[submission.type] && submission.ratings[submission.type].u650Exclusions;
    let nextKey = Math.max.apply(Math, u650Exclusion.map(sub => sub.key)) + 1;
    if (submission.totalCost <= 1000000 && submission.projectAddress.projectState === 'New York' && submission && submission.isESWorkExcluded === true) {
      u650Exclusion.push({
        key: nextKey,
        text: 'All work or activities involving new or ground up construction, land excavation, building foundation formation, exterior wall construction, structural beam installation, exterior façade or window work or vertical addition.',
      })
      nextKey += 1;
      const unique = u650Exclusion.filter(
        (obj, index) =>
          u650Exclusion.findIndex((item) => item.text === obj.text) === index
      );
      return unique
    }
    else if (submission.isESWorkExcluded === false) {
      let value = 'All work or activities involving new or ground up construction, land excavation, building foundation formation, exterior wall construction, structural beam installation, exterior façade or window work or vertical addition.'
      u650Exclusion = u650Exclusion.filter(item => item.text != value);
      return u650Exclusion
    }
    else {
      return u650Exclusion;
    }
  }
  else {
    return DEFAULT_EXCLUSION
  }
}

export {getExclusionU650, updateExclusionU650};